import { env } from '@/config/env'
import type { FirebaseApp } from 'firebase/app'

let appPromise: Promise<FirebaseApp> | null = null

export function getFirebaseApp(): Promise<FirebaseApp> {
  if (appPromise) return appPromise

  appPromise = initApp()
  return appPromise
}

async function initApp(): Promise<FirebaseApp> {
  const { apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId } = env.firebase

  if (!projectId) {
    throw new Error('Firebase project ID is not configured. Set VITE_FIREBASE_PROJECT_ID.')
  }

  const { initializeApp } = await import('firebase/app')

  return initializeApp({ apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId })
}

/** Reset for testing purposes only */
export function _resetFirebaseApp(): void {
  appPromise = null
}
